import { createAction, props } from '@ngrx/store';

export const updateDocumentNote = createAction(
    '[DOCUMENT NOTE API] Update Document Note',
    props<{ note: string; candidateDocumentId: number; noteId: number }>()
);
